module.exports = __webpack_public_path__ + "static/react-8458b75e3ac64707b1724a22b261157c.png";